import { useReactFlow, XYPosition } from '@xyflow/react';
import { useCallback } from 'react';
import { ShortNodeInfo } from '../normalizeGroupPositions';

export const useGetNodeAbsolutePosition = () => {
  const { getNode } = useReactFlow();

  const getNodeAbsolutePosition = useCallback(
    (idOrNode: string | ShortNodeInfo): XYPosition | undefined => {
      const node = typeof idOrNode === 'string' ? getNode(idOrNode) : idOrNode;
      if (!node) return undefined;

      const position = { ...node.position };

      if (node.parentId) {
        const parentPosition = getNodeAbsolutePosition(node.parentId);
        if (!parentPosition) return undefined;
        position.x += parentPosition.x;
        position.y += parentPosition.y;
      }

      return position;
    },
    [getNode],
  );

  return { getNodeAbsolutePosition };
};
